// extracted by mini-css-extract-plugin
module.exports = {"callCenterContainer":"AdacCallCenterPage_callCenterContainer__E5W0w"};